module.exports = __webpack_public_path__ + "img/placeholder-1080x1920.bd8ddd91.png";